import { Text } from '../../text/text';
import theme from '../../../style/theme';
import { ErrorCatcher } from '../../../tools/error-catcher';

type CheckboxProps = {
    whenClicked: (e?: any) => void;
    value: string;
    isChecked: boolean;
    name: string;
    // Sorry, name was taken.
    inputName?: string;
    hasErrors?: boolean;
    id?: string;
    inputRef?: (el: HTMLInputElement) => void;
    title?: string;
}


export const Checkbox = (props: CheckboxProps, hasErrors = false) => {    

    return (
        <>
    <ErrorCatcher componentName='Checkbox'>
        <label for={props.id || props.value} onInput={props.whenClicked}
            class={`relative flex items-center cursor-pointer
                [&>input]:mr-[0.9rem]
                max-mobile:py-[0.5rem]
                ${hasErrors ? 'border border-primary' : 'border-none'}
            `}
            >
                <input
                    id={props.id || props.value}
                    type='checkbox'
                    value={props.value}
                    name={props.inputName}
                    ref={props.inputRef}
                    title={props.title}
                    class="peer m-0 appearance-none border border-gray-dark bg-clip-content !p-0 cursor-pointer
                        w-[1.57rem] min-w-[1.57rem] h-[1.57rem] rounded-[0.36rem] checked:border-primary peer-checked:[&~span]:block bg-white"
                />
                <span
                    class="absolute top-1/2 left-0
                        h-[1.57rem] min-w-[1.57rem]
                        hidden peer-checked:block
                        after:absolute
                        after:block
                        after:content-['']
                        after:left-[0.5rem]
                        after:bottom-[1.2rem]
                        after:w-[0.54rem]
                        after:h-[0.91rem]
                        after:border-solid
                        after:border-primary
                        after:border-[0_0.21rem_0.21rem_0]
                        after:rotate-45"
                ></span>
            <Text 
                noBlockSpacing={true}
                fontSize='small'
                {...props.isChecked && {
                    color: theme.palette.primary
                }}
            >
                {props.name}
            </Text>
        </label>
        </ErrorCatcher>
</>
    );
};
